import React from 'react';
import { connect } from "react-redux";
import formatPhoneUS from "./helpers/formatPhoneUS";
import ApiServiceDGB from "./shared/ApiServiceDGB";
import Spinner from "./Spinner";
import { validTypes } from "./helpers/validDGBFileType";
import { Toaster } from 'react-hot-toast';
import { notifyError } from "./ToastMessages";
import FileUploadArea from "./DGBComponents/FileUploadArea";
import FileUploadPreview from "./DGBComponents/FileUploadPreview";

class AddVin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jwt: this.props.state.jwt,
            dgbApiUrl: this.props.state.dgbApiUrl,
            businessRef: this.props.business.reference,
            vin: '',
            vinError: false,
            vinLength: 0,
            phoneNumber: '',
            files: [],
            error: null,
            uploadedFiles: [],
            disabledSave: true,
            checkingPhone: false,
            verifiedPhoneExists: false,
            existingUser: [],
            showSpinner: false,
        };

        this.apiService = new ApiServiceDGB(this.state.dgbApiUrl, this.props.state.jwt);
    }

    handleVinChange = (event) => {
        const vin = event.target.value;
        this.setState({ vin, vinLength: vin.length });

        if (vin.length === 17) {
            this.setState({disabledSave: false});
        }
    }

    handleVinBlur = () => {
        const { vin } = this.state;
        this.setState({ vinError: vin.length !== 17 });
    }

    handlePhoneNumberChange = (event) => {
        const phoneNumber = formatPhoneUS(event.target.value);
        this.setState({ phoneNumber });
    }

    searchPhone = async (phone) => {
        const { businessRef } = this.state;
        this.setState({
            checkingPhone: true
        });

        try {
            const response = await this.apiService.searchPhoneNumber(businessRef, phone);

            if (response[0]["_id"]) {
                this.setState({
                    checkingPhone: false,
                    verifiedPhoneExists: true,
                    existingUser: response,
                    disabledSave: false
                });
            }

        } catch (error) {
            console.log('Error checking phone number', error);
            this.setState({
                checkingPhone: false,
                verifiedPhoneExists: false,
                existingUser: [],
                disabledSave: false
            });

        }
    }

    handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const invalidFiles = files.filter(file => !validTypes.includes(file.type));

        if (invalidFiles.length > 0) {
            notifyError(('Unsupported file type(s):') + `${invalidFiles.map(file => file.name).join(", ")}`);
            event.target.value = "";
            return;
        }

        if (files && files.length > 0) {
            const uploadedFiles = files.map((file) => ({
                name: file.name,
                type: file.type,
                url: URL.createObjectURL(file),
                fileObject: file
            }));

            this.setState((prevState) => ({
                uploadedFiles: [...prevState.uploadedFiles, ...uploadedFiles],
            }));
        }
    };

    removeImg = (index) => () => {
        this.setState((prevState) => {
            const uploadedFiles = [...prevState.uploadedFiles];
            uploadedFiles.splice(index, 1);
            return { uploadedFiles: uploadedFiles };
        });
    };

    handleSubmit = async () => {
        const { vin, phoneNumber, existingUser, businessRef, uploadedFiles } = this.state;

        const formData = new FormData();

        formData.append('vin', vin);
        formData.append('reference', businessRef);

        if (existingUser.length > 0) {
            formData.append('user', existingUser[0]._id);
        }

        if (existingUser.length < 1 && phoneNumber) {
            const phoneNumbers = phoneNumber.split(',').map(phone => phone.trim());
            phoneNumbers.forEach(phone => {
                const cleanPhone = phone.replace(/\D/g, '');
                const phoneWithPrefix = cleanPhone.startsWith("+1") ? cleanPhone : "+1" + cleanPhone
                formData.append('phones[]', phoneWithPrefix)
            });
        }

        if (uploadedFiles.length > 0) {
            uploadedFiles.forEach((file) => {
                formData.append('files', file.fileObject);
            });
        }

        this.startSpinner();

        try {
            const response = await this.apiService.addVin(businessRef, formData);

            if (!response.ok) {
                const errorText = await response.text();
                if (errorText.toLowerCase().includes('invalid token')) {
                    window.location.replace(window.location.origin + '/logout');
                }
                throw new Error('Network response was not ok');
            } else {
                window.location.href = `manage-vins/${this.state.vin}`;
            }

            this.stopSpinner();

        } catch (error) {
            console.error('Error adding VIN', error);

            if (error.path) {
                this.setState({ error: error });
                this.stopSpinner( __(error.msg), 'error' );
            } else {
                const displayErrorMessage = error?.message
                    ? error?.message
                    : error?.contains('Unauthorized')
                        ? 'Unauthorized'
                        : 'Error adding VIN';
                this.setState({ error: displayErrorMessage });
                this.stopSpinner( __(displayErrorMessage), 'error' );
            }
        }
    }

    startSpinner () {
        this.setState({
            showSpinner: true,
            spinnerState: 'sync',
            spinnerText: __('Adding VIN')
        })
    }

    stopSpinner (customMessage, state = 'success') {
        this.setState({
            spinnerState: state,
            spinnerText: customMessage ? customMessage : __('Successfully added')
        })
        setTimeout(() => {
            this.setState({
                showSpinner: false,
                spinnerState: 'sync',
                spinnerText: ''
            })
        }, 1500)
    }
    render() {
        const goToManage = () => {
            const currentPath = window.location.pathname;
            const newPath = currentPath.replace('/add-vin', '/manage-vins');
            window.location.href = newPath;
        };

        return (
            <div className="edit-vin w-100 right-side-content">
                <div className="main-section">
                    <div className="w-100 p-2 bg-white border-bottom d-flex align-items-center p-3">
                        <button className="btn btn-xs btn-outline-primary ml-2 mr-3 text-nowrap"
                                onClick={goToManage}>{__('Back to Manage VINs')}</button>
                        <p className='mb-0 w-100'>{__('Adding a new VIN')}.</p>
                    </div>
                </div>

                <div className="w-100 p-2 bg-white d-flex flex-column align-items-start p-3">
                    <h4>{__('Please enter the new VIN:')}</h4>
                    <div className="d-flex flex-column">
                        <div className="input-group feedback-form-control w-50 mr-3 dgb-input dgb-input--phone">
                            <input
                                placeholder='Enter VIN'
                                className="pl-2 pt-1 pb-1"
                                value={this.state.vin}
                                onChange={this.handleVinChange}
                                onBlur={this.handleVinBlur}
                                error={this.state.vinError ? 'true' : undefined}
                                maxLength={17}
                                type='text'
                            />
                        </div>
                        <p className='mt-2'>{`VIN length: ${this.state.vinLength} / 17`}</p>

                        {/* Error Message */}
                        {this.state.vinError &&
                            <p style={{color: 'red'}}>{__('VIN must be exactly 17 characters long')}</p>}

                        {(this.state.error?.path === 'vin' && this.state.error.message) &&
                            <p className='mt-3' style={{color: 'red'}}>{this.state.error.message}</p>
                        }


                        {/* Phone */}
                        <div className="d-flex flex-column mt-3">
                            <p>{ __('Please enter a cell number') }</p>
                            <div className='row m-0'>
                                <div className="input-group feedback-form-control w-50 mr-3 dgb-input dgb-input--phone">
                                    <input
                                        placeholder='Add a cell number'
                                        type="tel"
                                        className="pl-2 pt-1 pb-1"
                                        value={formatPhoneUS(this.state.phoneNumber) || ''}
                                        maxLength={14}
                                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                        onChange={this.handlePhoneNumberChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        onKeyUp={(event) => {
                                            if (event.target.value.length === 14) {
                                                this.searchPhone(event.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                {this.state.checkingPhone &&
                                    <i className='fa fa-spinner dgb-phone-check-spinner'></i>
                                }

                                {this.state.verifiedPhoneExists &&
                                    <i className='fas fa-check dgb-phone-check'></i>
                                }
                            </div>

                            {(this.state.error?.path === 'phones' && this.state.error.message) &&
                                <p className='mt-3' style={{color: 'red'}}>{this.state.error.message}</p>
                            }
                        </div>
                    </div>

                    {/* Files */}
                    <div className="d-flex flex-column mt-4">
                        <label>{__('Attach Files')}</label>
                        <div className='dgb-upload-component'>
                            <div className="dgb-upload-wrapper">
                                <input
                                    onChange={this.handleFileChange}
                                    className="dgb-upload-input"
                                    type="file"
                                    accept="image/* application/pdf"
                                    name="file"
                                    id="file-upload"
                                    multiple
                                />

                                {this.state.uploadedFiles && this.state.uploadedFiles.length > 0 ? (
                                    <ul className="attachments-preview-wrapper">
                                        {this.state.uploadedFiles.map((img, i) => (
                                            <li key={i}>
                                                {img.type.includes('image') ? (
                                                    <img src={img.url} alt={`Attachment ${i}`}/>
                                                ) : (
                                                    <FileUploadPreview img={img} />
                                                )}

                                                <button onClick={this.removeImg(i)}>
                                                    <svg
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 13 13"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M.293 1.293a1 1 0 0 1 1.414 0L6 5.586l4.293-4.293a1 1 0 1 1 1.414 1.414L7.414 7l4.293 4.293a1 1 0 0 1-1.414 1.414L6 8.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L4.586 7 .293 2.707a1 1 0 0 1 0-1.414Z"
                                                            fill="#FEFEFE"
                                                            fillOpacity=".996"
                                                        />
                                                    </svg>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <FileUploadArea />
                                )}
                            </div>

                            {(this.state.error?.path === 'files' && this.state.error.message) &&
                                <p className='mt-3' style={{color: 'red'}}>{this.state.error.message}</p>
                            }
                        </div>

                    </div>

                    {/* Save VIN */}
                    <button
                        className="btn btn-primary mt-4"
                        onClick={this.handleSubmit}
                        disabled={this.state.vin.length !== 17 || this.state.vinError || this.state.disabledSave}
                    >{__('Save VIN')}</button>

                    {/* Error Message */}
                    {(!this.state.error?.path && this.state.error) &&
                        <p className='mt-3' style={{color: 'red'}}>{this.state.error?.msg || this.state.error}</p>
                    }

                </div>

                {/* Spinner */}
                {this.state.showSpinner &&
                    <Spinner spinnerState={this.state.spinnerState} spinnerText={this.state.spinnerText}/>
                }

                {/* Toast */}
                <Toaster
                    position="top-center"
                    toastOptions={{
                        duration: 3000,
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        business: state.business,
        vin: state.current_vin
    }
}

export default connect(mapStateToProps)(AddVin)
